export const lightTheme = {
  body: "#FFF",
  text: "#333",
  alternateText: "#FAFAFA",
  headerText: "#FFF",
  textSecondary: "#fff",
  background: "#363537",
  primary: "#487EB0",
  secondary: "#223C79",
  tertiary: "#219451",
};

export const darkTheme = {
  body: "#121212",
  text: "#FAFAFA",
  alternateText: "#333",
  headerText: "#FFF",
  textSecondary: "#fff",
  background: "#999",
  primary: "#27AE60",
  secondary: "#32E67D",
  tertiary: "#219451",
};

/*

DOCUMENTATION

This website theme supports dark and light mode. lightTheme lists all the colors used in light mode. darkTheme lists all the colors used in dark mode.
Any color in lightTheme has an opposite color in darkTheme.
--body
The color of the body of the theme
--text
The main text color of the theme. This color will contrast with the "body" color. 
--alternateText
The color used on a colored background. This color will contrast with your "primary" color.
--headerText
The color used for main headings to sections. This color will contrast with your "primary" color.
--textSecondary
The color used on a colored background. This color will contrast with your "primary" color.
--background
This is the backround color used in the Privacy, Support and Terms pages.
--primary
The primary or main color of your theme.
--secondary
This should be a slightly lighter color to your "primary" color.
--tertiary
This should be a darker color to your "primary" color. 

*/
